import { env } from '../config/env';

// Sends the browser to the customer-portal login, asking it to return to our
// SSO callback with the JWT. The customer portal allowlists this return origin.
export function redirectToCustomerLogin(): void {
  const returnUrl = `${window.location.origin}/training/auth/callback`;
  window.location.href = `${env.CUSTOMER_LOGIN_URL}?return=${encodeURIComponent(returnUrl)}`;
}
